import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_branch_location_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_branch_location_link_RowClass implements bl_fi_mst_branch_location_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
